<div class="portal">
  <eeule-admin-main-drawer>
    <eeule-admin-page-header>
    </eeule-admin-page-header>
    <div class="portal-outlet">
      <router-outlet/>
    </div>
  </eeule-admin-main-drawer>
</div>
